export default "__VITE_ASSET__DTFoAyhS__"